module.exports = __webpack_public_path__ + "static/media/kuro_analytics_ill.702cfd78.svg";